export enum RouteKey {
  login = 'login',
  monitoramento = 'monitoramento',
  indicadores = 'indicadores',
  relatorios = 'relatorios',
  sumario = 'sumario',
  sumariodemaquinas = 'sumariodemaquinas',
}
